import { Injectable } from '@angular/core';
import { OnPremiseProvider } from './on-premise';

const KEY_NAME = 'wheatleyToken';

@Injectable()
export class WheatleyProvider {
    constructor(private onPremiseProvider: OnPremiseProvider) {}

    public async setToken(token: string): Promise<void> {
        if (this.onPremiseProvider.isOnPremiseElectronApp()) {
            await this.onPremiseProvider.setWheatleyToken(token);
        } else {
            const domain = location.host.replace(`:${location.port}`, '');
            const expirationDate = new Date();
            expirationDate.setSeconds(expirationDate.getSeconds() + 3600 * 24 * 30);

            document.cookie = `${KEY_NAME}=${token}; expires=${expirationDate.toUTCString()}; path=/; domain=${domain};`;
        }
    }

    public async getToken(): Promise<string> {
        if (this.onPremiseProvider.isOnPremiseElectronApp()) {
            return await this.onPremiseProvider.getWheatleyToken();
        } else {
            return this.getWebCookie(KEY_NAME);
        }
    }

    public async deleteToken(): Promise<void> {
        if (this.onPremiseProvider.isOnPremiseElectronApp()) {
            await this.onPremiseProvider.deleteWheatleyToken();
        } else {
            const domain = location.host.replace(`:${location.port}`, '');
            document.cookie = `${KEY_NAME}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${domain};`;
        }
    }

    /**
     * Gets the stored value of key from cookie
     *
     * @return string value of the stored key
     */
    private getWebCookie(cname: string): string {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${cname}=`);
        if (parts && parts.length == 2) {
            const result = parts[parts.length - 1].split(';').shift();
            if (result) {
                return result;
            } else {
                return '';
            }
        } else {
            return '';
        }
    }
}



// WEBPACK FOOTER //
// ./src/providers/wheatley.ts